import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';

interface DownloadAppPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
}
@inject('app', 'site', 'user', 'thread')
@observer
class DownloadAppPCPage extends BasePage<DownloadAppPCPageProps> {
    componentDidMount() {
        const { app, user, thread } = this.props;
        super.componentDidMount();
    }

    render() {
        return ( <div className={styles.wrapper}>
            <div className={styles.downloadBox}>
                <div className={styles.downloadRight}>
                    {/* <div className={styles.downloadTitle}>vivo社区APP</div> */}
                    <img src={`${BASE_IMG_URL}/common/logo2.png`} alt="" className={styles.downloadSubLogo} />
                    <div className={styles.downloadTip}>与热爱同行</div>
                    <img src={`${BASE_IMG_URL}/qrcode/downloadApp.png`} className={styles.codeImg} />
                    <p className={styles.downloadInfo}>手机浏览器<span>扫码下载</span>体验或<br/><span>vivo应用商店</span>搜索“vivo社区”安装体验</p>
                </div>
                <img src={`${BASE_IMG_URL}/common/download_bg4.png`} alt="" className={styles.exampleImg} />
                
                {/* <img src={`${BASE_IMG_URL}/common/app_logo.png`} alt="" className={styles.downloadLogo}/>
                <div className={styles.downloadTitle}>vivo社区APP</div>
                <div className={styles.downloadTip}>与热爱同行</div> */}
                
            </div>
        </div>)
    }
}

export default withRouter(DownloadAppPCPage);
